import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_dp7uqthd78: FaireBrandEntity = {
  token: "b_dp7uqthd78",
  type: "brand",
  name: "Blue Star Press",
  avatarUrl:
    "https://cdn.faire.com/fastly/fcf36d45c9031995a3f3f10fe14baf013ee8bbe493e4c462696cf2d12e47d2b2.webp",
  bannerUrl:
    "https://cdn.faire.com/fastly/e9b1a6e107ce55638c0e50c331acb484bc68aafe9858bf6f9f3af41e073a2d50.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/fcf36d45c9031995a3f3f10fe14baf013ee8bbe493e4c462696cf2d12e47d2b2.webp",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e9b1a6e107ce55638c0e50c331acb484bc68aafe9858bf6f9f3af41e073a2d50.jpeg",
  location: "Bend, OR, USA",
  minimumOrderDollars: 50,
  rating: 5,
  reviewCount: 64,
  isTopShop: true,
  isInsider: true,
  description:
    "Blue Star Press is an award-winning independent publisher based in Bend, OR. Established in 2015, we are a team of industry outsiders who love to think creatively, push boundaries, and reimagine what’s possible with books, games, and gift products. In 2024, Blue Star Press acquired Seattle-based Sasquatch Books, uniting our shared values of creativity, premium quality, and highly visual books for adults and children. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:40.641Z",
    importedBy: "entity-db-cli",
  },
};
